<template>
    <div class="w-full border-b border-gray-200" />
</template>
